function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTimeoutLogs } from '@/actions/LogActions';
import { Button, Icon } from '@chakra-ui/react';
import React, { useCallback, useContext } from 'react';
import Table from '../Table';
import dayjs from '@/utils/dayjs';
import { LogContext } from '../layouts/LogsLayout';
import TableHeading from '../TableHeading';
import useChannelStore from '@/stores/ChannelStore';
import { useLimitQueryState, usePageQueryState, useSortDirectionQueryState } from '@/hooks/usePaginationQueryState';
import useQueryState from '@/hooks/useQueryState';
import { SortDirections } from '@/types/client';
import TimeoutReasonTag from '../TimeoutReasonTag';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHammer, faShield } from '@fortawesome/free-solid-svg-icons';
import { useDebounce } from 'use-debounce';
import EmptyState from '@/components/EmptyState';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { WebRoutes } from '@/utils/constants';
import Pagination from '../Pagination';
import { Table as MantineTable, Text } from '@mantine/core';
import styles from './TimeoutLogs.module.scss';
import useIntlMemo from '@/hooks/useIntlMemo';
var HeadingKeys;
(function(HeadingKeys) {
    HeadingKeys["CREATED_AT"] = "createdAt";
})(HeadingKeys || (HeadingKeys = {}));
function TimeoutLogsHeader(param) {
    var sortBy = param.sortBy, sortDirection = param.sortDirection, setSortDirection = param.setSortDirection, setSortBy = param.setSortBy;
    function handleSortChange(key, direction) {
        setSortDirection(direction);
        setSortBy(direction != null ? key : null);
    }
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                className: styles.createdAtColumn,
                active: sortBy === "createdAt",
                sort: sortDirection,
                setSort: function(direction) {
                    return handleSortChange("createdAt", direction);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "wittYy",
                    defaultMessage: "Created At"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "CHXoWz",
                    defaultMessage: "Actor"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "T7Ry38",
                    defaultMessage: "Message"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                alignRight: true,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "AkCxS/",
                    defaultMessage: "Reason"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                alignRight: true,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "BACCkG",
                    defaultMessage: "Length"
                })
            })
        ]
    });
}
function TimeoutLogRow(param) {
    var totalSeconds = param.length, reason = param.reason, targetUser = param.targetUser, createdAt = param.createdAt, message = param.message;
    var formattedLength = useIntlMemo(function(intl) {
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor(totalSeconds % 3600 / 60);
        var seconds = totalSeconds % 60;
        var fractionUnits = [
            {
                value: hours,
                unit: 'hour'
            },
            {
                value: minutes,
                unit: 'minute'
            },
            {
                value: seconds,
                unit: 'second'
            }
        ].filter(function(param) {
            var value = param.value;
            return value > 0;
        }).map(function(param) {
            var value = param.value, unit = param.unit;
            return intl.formatNumber(value, {
                style: 'unit',
                unit: unit
            });
        });
        if (fractionUnits.length === 0) {
            return intl.formatNumber(0, {
                style: 'unit',
                unit: 'second'
            });
        }
        return intl.formatList(fractionUnits, {
            type: 'unit'
        });
    }, [
        totalSeconds
    ]);
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                visibleFrom: "sm",
                className: styles.createdAtColumn,
                children: /*#__PURE__*/ _jsx(Text, {
                    children: dayjs(createdAt).format('MMM D, h:mm A')
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                visibleFrom: "sm",
                className: styles.userColumn,
                children: /*#__PURE__*/ _jsx(Text, {
                    children: targetUser.displayName
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.messageColumn,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.userStack,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            hiddenFrom: "sm",
                            children: targetUser.displayName
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            className: styles.userTimestamp,
                            hiddenFrom: "sm",
                            children: dayjs(createdAt).format('MMM D, h:mm A')
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            size: "sm",
                            className: styles.userMessage,
                            children: message
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.reasonColumn,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.reasonStack,
                    children: [
                        /*#__PURE__*/ _jsx(TimeoutReasonTag, {
                            reason: reason
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            className: styles.reasonLength,
                            hiddenFrom: "sm",
                            children: formattedLength
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                visibleFrom: "sm",
                className: styles.lengthColumn,
                children: /*#__PURE__*/ _jsx(Text, {
                    children: formattedLength
                })
            })
        ]
    });
}
export default function TimeoutLogs() {
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var navigate = useNavigate();
    var _React_useState = _sliced_to_array(React.useState(null), 2), timeoutLogs = _React_useState[0], setTimeoutLogs = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(0), 2), totalTimeoutLogs = _React_useState1[0], setTotalTimeoutLogs = _React_useState1[1];
    var _useContext = useContext(LogContext), search = _useContext.search, setIsSearching = _useContext.setIsSearching;
    var _useDebounce = _sliced_to_array(useDebounce(search, 500), 1), debouncedSearch = _useDebounce[0];
    var _usePageQueryState = _sliced_to_array(usePageQueryState(), 2), page = _usePageQueryState[0], setPage = _usePageQueryState[1];
    var _useLimitQueryState = _sliced_to_array(useLimitQueryState(), 2), limit = _useLimitQueryState[0], setLimit = _useLimitQueryState[1];
    var _useSortDirectionQueryState = _sliced_to_array(useSortDirectionQueryState(SortDirections.DESC), 2), sortDirection = _useSortDirectionQueryState[0], setSortDirection = _useSortDirectionQueryState[1];
    var _useQueryState = _sliced_to_array(useQueryState('sortBy', {
        defaultValue: "createdAt"
    }), 2), sortBy = _useQueryState[0], setSortBy = _useQueryState[1];
    var loadTimeoutLogs = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(page, limit, query, sortBy, sortDirection) {
            var _ref, newTimeoutLogs, total, currentChannel;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (channel == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            getTimeoutLogs(channel._id, {
                                limit: limit,
                                offset: page * limit,
                                query: query != null && query.length > 0 ? query : undefined,
                                sortBy: sortBy !== null && sortBy !== void 0 ? sortBy : undefined,
                                direction: sortDirection !== null && sortDirection !== void 0 ? sortDirection : undefined
                            })
                        ];
                    case 1:
                        _ref = _state.sent(), newTimeoutLogs = _ref.timeoutLogs, total = _ref.total;
                        currentChannel = useChannelStore.getState().channel;
                        if (currentChannel == null || currentChannel._id !== channel._id) {
                            return [
                                2
                            ];
                        }
                        setTotalTimeoutLogs(total);
                        setTimeoutLogs(newTimeoutLogs);
                        setIsSearching(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(page, limit, query, sortBy, sortDirection) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        channel
    ]);
    // handle initial load, channel changes, search changes
    React.useEffect(function() {
        if (channel == null) {
            return;
        }
        if (page !== 0) {
            setPage(0);
            return;
        }
        loadTimeoutLogs(page, limit, debouncedSearch, sortBy, sortDirection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel,
        loadTimeoutLogs,
        debouncedSearch
    ]);
    // handle pagination/sorting changes
    React.useEffect(function() {
        if (channel == null || timeoutLogs == null) {
            return;
        }
        loadTimeoutLogs(page, limit, debouncedSearch, sortBy, sortDirection);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        page,
        limit,
        sortBy,
        sortDirection
    ]);
    // set searching state when search changes, not when we start loading results
    React.useEffect(function() {
        if (search.length === 0) {
            return;
        }
        setIsSearching(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search
    ]);
    return /*#__PURE__*/ _jsx(Table, {
        data: timeoutLogs,
        extraData: [
            totalTimeoutLogs,
            navigate,
            page,
            limit,
            sortDirection,
            sortBy
        ],
        keyExtractor: function(log) {
            return "".concat(log.createdAt, "-").concat(log.user.providerId);
        },
        renderFooter: function() {
            return /*#__PURE__*/ _jsx(Pagination, {
                limit: limit,
                page: page,
                total: totalTimeoutLogs,
                setLimit: setLimit,
                nextPage: function() {
                    return setPage(page + 1);
                },
                previousPage: function() {
                    return setPage(page - 1);
                }
            });
        },
        renderHeader: function() {
            return /*#__PURE__*/ _jsx(TimeoutLogsHeader, {
                sortBy: sortBy,
                setSortBy: setSortBy,
                setSortDirection: setSortDirection,
                sortDirection: sortDirection
            });
        },
        renderEmptyState: function() {
            return /*#__PURE__*/ _jsx(EmptyState, {
                title: intl.formatMessage({
                    id: "OQAgdW",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "No Timeouts"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "vI7lqa",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Timeout logs are when a user is timed out, controlled by your chat moderation settings."
                        }
                    ]
                }),
                icon: /*#__PURE__*/ _jsx(Icon, {
                    fontSize: "4xl",
                    as: FontAwesomeIcon,
                    icon: faHammer
                }),
                buttons: [
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: function() {
                            return navigate(WebRoutes.MODERATION);
                        },
                        leftIcon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: faShield
                        }),
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "LEYszE",
                            defaultMessage: "Chat Moderation Settings"
                        })
                    }, "spam-protection-settings")
                ]
            });
        },
        renderRow: function(log) {
            return /*#__PURE__*/ _jsx(TimeoutLogRow, _object_spread({}, log));
        }
    });
}
